import AddIcon from '@mui/icons-material/Add';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import OrderSubsectionCard from '../Common/OrderSubsectionCard';
import { SkillsProcedure } from './SkillsProcedure';

export const SkillsProcedureSubSection = () => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <OrderSubsectionCard
          icon={<KeyboardArrowDownIcon sx={theme=>({ color: theme.palette.framework.system.doveGray })} />}
          addIcon={<AddIcon sx={{ color: theme => theme.palette.system.neutralGray }} />}
          title={t('order.newOrderCreation.tabs.skills')}
          children={<SkillsProcedure />}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <OrderSubsectionCard
          icon={<KeyboardArrowDownIcon sx={theme=>({ color: theme.palette.framework.system.doveGray })} />}
          title={t('order.newOrderCreation.tabs.emr')}
          children={<SkillsProcedure />}
          addIcon={<AddIcon sx={{ color: theme => theme.palette.system.neutralGray }} />}
        />
      </Grid>
    </Grid>
  );
};
